import api from './index'

function get (success, error, profile) {
  if (profile) {
    return api.get(profile.company, success, error)
  } else {
    return api.profile.get((profile) => {
      api.get(profile.company, success, error)
    }, error)
  }
}

function sync (company, callbacks, error) {
  return api.subscribe(company, callbacks, null, error)
}


export default {
  get,
  sync
}



// WEBPACK FOOTER //
// ./src/api/companies.js